<template>
	<div class="stat-box" id='graph_offre'>
		<div class="stat-box-header">
			<div class="flex align-items-center surface-card">
				<div style="width:48px;height:48px;border-radius:10px" class="bg-blue-100 inline-flex align-items-center justify-content-center mr-3">
					<i class="pi pi-building text-blue-500 text-3xl"></i>
				</div>
				<div>
					<span class="text-900 text-xl font-medium mb-2">{{ $t('historique') }}</span>
					<p class="mt-1 mb-0 text-600 font-medium text-sm">{{ $t('de_la_ventilation_de_loffre') }}</p>
				</div>
				<div class="ml-auto" style="visibility: hidden;">
					<div>
						<Button  icon="pi pi-image" class="p-button-rounded" @click="$store.dispatch('ExportToPng',{id: 'groff'})" />
					</div>
				</div>
			</div>
		</div>
		<div class="stat-box-content" id="groff">
			<div class="graph">
				<!--<highcharts :options="chartOptions"></highcharts>-->
				<apexchart
					ref="groff"
					id="groff"
					width="100%"
					height="280"
					:options="chartOptions"
					:series="chartSeries"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
//import { Chart } from 'highcharts-vue'
import Button from 'primevue/button';

export default {
	name: 'GraphOffre',
	props: {
		periode_forme: { default: 'statistique_secteurs_trimestre' },
		nbperiode: { default: 8 },
		cle: { default: 'trimestre' },
		libperiode: { default: 'trimestres' },
	},

	data: function() {
		return {
			items: [
				{label: 'Image', icon: 'pi pi-fw pi-image', command:() => {this.$store.dispatch('ExportToPng',{id: 'groff'});} },
			],
			chartSeries: [
				{ name: 'Sur plan', data: Array(8).fill(0) },
				{ name: 'En chantier', data: Array(8).fill(0) },
				{ name: 'Livrée', data: Array(8).fill(0) }
			],
			chartOptions: {
				chart: {
					type: 'bar',
					//type: 'area',
					stacked: true,
					stackType: '100%',
					fontFamily: 'Nunito',
					toolbar: {
						show: true, // Affiche la toolbar
						tools: {
							download: true, // Active le bouton de téléchargement
							selection: false,
							zoom: false,
							zoomin: false,
							zoomout: false,
							pan: false,
							reset: false
						},
						export: {
							csv: {
								filename: 'export-data',
								columnDelimiter: ',',
								headerCategory: 'Category',
								headerValue: 'Value'
							},
							svg: {
								filename: 'export-graph'
							},
							png: {
								filename: 'export-graph'
							}
						}
					},
				},
				colors: ['#f44336', '#8BC34A', '#2196F3'],
				dataLabels: {
					enabled: false
				},
				//stroke: {
				//	curve: 'smooth'
				//},
				//fill: {
				//	type: 'gradient',
				//	gradient: {
				//		shadeIntensity: 1,
				//		opacityFrom: 0.3,
				//		opacityTo: 0,
				//		stops: [0, 100]
				//	}
				//},
				xaxis: {
					categories: Array(8).fill(''),
					labels: { style: { colors: '#666' } },
					tickPlacement: 'on'
				},
				yaxis: {
					labels: {
						formatter: (val) => `${val.toFixed(0)}%`,
						style: { colors: '#666' }
					},
					max: 100
				},
				//tooltip: {
				//	shared: true,
				//	y: {
				//		formatter: (val) => `${val.toFixed(0)}%`
				//	}
				//},
				legend: {
					position: 'top'
				},
				grid: {
					borderColor: '#ddd',
					strokeDashArray: 4
				}
			}
			
			/*chartOptions: {
				accessibility: {
					enabled: false
				},
				credits: {
					enabled: false
				},
				title: '',
				chart: {
					height: 280,
					type: 'area',
					style: {
						fontFamily: 'Nunito',
					}
				},
                xAxis: {
                        categories: ['1750', '1800', '1850', '1900', '1950', '1999', '2050'],
                        tickmarkPlacement: 'on',
                        title: {
                            enabled: false
                        }
                },
                yAxis: {
                    labels: {
                        format: '{value}%'
                    },
                    title: {
                        enabled: false
                    }
                },
                plotOptions: {
                    area: {
                        stacking: 'percent',
                        lineColor: '#ffffff',
                        lineWidth: 1,
                        marker: {
                            lineWidth: 1,
                            lineColor: '#ffffff'
                        },
                        accessibility: {
                            pointDescriptionFormatter: function (point) {
                                function round(x) {
                                    return Math.round(x * 100) / 100;
                                }
                                return (point.index + 1) + ', ' + point.category + ', ' +
                                    point.y + ' millions, ' + round(point.percentage) + '%, ' +
                                    point.series.name;
                            }
                        }
                    }
                },
				series: [
					{
						color: '#f44336',
						name: "Sur plan",
						data: [0,0,0,0,0,0,0,0],
						fillColor: {
							linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
							stops: [
								[0, 'rgba(244,67,54,0.3)'],
							]
						},
						marker: {
							symbol: 'circle',
							enabled: false
						}
					},
					{
						color: '#8BC34A',
						name: "En chantier",
						data: [0,0,0,0,0,0,0,0],
						fillColor: {
							linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
							stops: [
								[0, 'rgba(139,195,74,0.3)'],
							]
						},
						marker: {
							symbol: 'circle',
							enabled: false
						}
					},
					{
						color: '#2196F3',
						name: "livrée",
						data: [0,0,0,0,0,0,0,0],
						fillColor: {
							linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
							stops: [
								[0, 'rgba(33,150,243,0.3)'],
							]
						},
						marker: {
							symbol: 'circle',
							enabled: false
						}
					},
				],
			}
				*/
		}
	},

	computed: Object.assign(mapGetters([ 'app' ]), {
		
	}),

	methods: {
/*
		maj_periode: function(k) {
			let t = []
			let a = this.app.livedata[this.periode_forme].slice().reverse()
			for (let index=0; index < this.nbperiode; index++) {
				t.push(a[index]['ventilation_offre'][k])
			}
			return t;
		},

		TraitementTitre: function(t) {
			if (this.app.tab == 'trimestres') {
				return t.slice(-4);
			} else return t;
		},

		maj_titre: function() {
			let t = []
			let a = this.app.livedata[this.periode_forme].slice().reverse()
			for (let index=0; index < this.nbperiode; index++) {
				t.push(this.TraitementTitre(a[index][this.cle]))
			}
			return t;
		},

		maj: function() {
			this.chartOptions.series[0].data = this.maj_periode('surplan')
			this.chartOptions.series[1].data = this.maj_periode('enchantier')
			this.chartOptions.series[2].data = this.maj_periode('livre')
			this.chartOptions.xAxis.categories = this.maj_titre()
		}
*/
		maj_periode(k) {
			const t = []
			const a = this.app.livedata[this.periode_forme]?.slice()?.reverse() || []
			for (let index = 0; index < this.nbperiode; index++) {
				t.push(a[index]?.ventilation_offre?.[k] ?? 0)
			}
			return t
		},

		TraitementTitre(t) {
			return this.app.tab === 'trimestres' ? t.slice(-4) : t
		},

		maj_titre() {
			const t = []
			const a = this.app.livedata[this.periode_forme]?.slice()?.reverse() || []
			for (let index = 0; index < this.nbperiode; index++) {
				t.push(this.TraitementTitre(a[index][this.cle]))
			}
			return t
		},

		maj() {
			let option = {
				chart: {
					//type: 'area',
					type: 'bar',
					stacked: true,
					stackType: '100%',
					fontFamily: 'Nunito',
					toolbar: {
						show: true, // Affiche la toolbar
						tools: {
							download: true, // Active le bouton de téléchargement
							selection: false,
							zoom: false,
							zoomin: false,
							zoomout: false,
							pan: false,
							reset: false
						},
						export: {
							csv: {
								filename: 'export-data',
								columnDelimiter: ',',
								headerCategory: 'Category',
								headerValue: 'Value'
							},
							svg: {
								filename: 'export-graph'
							},
							png: {
								filename: 'export-graph'
							}
						}
					},
				},
				colors: ['#f44336', '#8BC34A', '#2196F3'],
				dataLabels: {
					enabled: false
				},
				//stroke: {
				//	curve: 'smooth'
				//},
				//fill: {
				//	type: 'gradient',
				//	gradient: {
				//		shadeIntensity: 1,
				//		opacityFrom: 0.3,
				//		opacityTo: 0,
				//		stops: [0, 100]
				//	}
				//},
				xaxis: {
					categories: this.maj_titre(),
					labels: { style: { colors: '#666' } },
					tickPlacement: 'on'
				},
				yaxis: {
					labels: {
						formatter: (val) => `${val.toFixed(0)}%`,
						style: { colors: '#666' }
					},
					max: 100
				},
				//tooltip: {
				//	shared: true,
				//	y: {
				//		formatter: (val) => `${val.toFixed(0)}%`
				//	}
				//},
				legend: {
					position: 'top'
				},
				grid: {
					borderColor: '#ddd',
					strokeDashArray: 4
				}
			}
			this.chartOptions = option
			this.chartSeries[0].data = this.maj_periode('surplan')
			this.chartSeries[1].data = this.maj_periode('enchantier')
			this.chartSeries[2].data = this.maj_periode('livre')
			this.$store.commit('SET_CHART_REF', {r: this.$refs['groff'], g: 'groff'});
		}

	},

	mounted: function() {
		this.maj()
		this.$store.commit('SET_CHART_REF', {r: this.$refs['groff'], g: 'groff'});
	},

	watch: {
		'app.livedata': function() {
			if (this.app.view == 'report' || this.app.view == 'report_B') {
				this.maj()
			}
		},
		'app.tab': function() {
			this.maj()
		},
	},
	
	components: { /*highcharts: Chart,*/ Button }
}
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'

.stat-box
	.stat-box-content
		padding 0 16px

.graph
	min-height 200px
	text-align center
	line-height @height


</style>
